import React from "react";


import { Col, Row } from "react-bootstrap";


import {
    CardComponent,
    CardMainTitleComponent,
    CardMainDescriptionComponent, CardDecorationByOrderComponent,
} from "@Components/Elements";


import "./index.scss";


export type ExplanationCardComponentDecorationType = {
    cardDecorationType: 'orderNr' | 'icon';
    cardDecorationValue: string;
};

type ExplanationCardComponentProps = {
    cardDecoration: ExplanationCardComponentDecorationType;
    cardMainTitle: string;
    cardDescription?: string;
    xs?:number; xl?: number;
};

export const ExplanationCardComponent:React.FC<ExplanationCardComponentProps> = ({
    cardDecoration,
    cardMainTitle, cardDescription,
    xs = 12, xl,
}) => {


    if (!cardMainTitle && !cardDescription) {
        return null;
    }

    let Component = null;

    switch (cardDecoration.cardDecorationType) {
        case 'orderNr':
            Component = <CardDecorationByOrderComponent
                orderValue={cardDecoration.cardDecorationValue}
            />;
            break;
        case 'icon':
            break;
    }


    return (
        <CardComponent
            type={1}
            className={`explanation-card-component`}
            xs={xs} xl={xl ?? xs}
        >

            <Col xs={'auto'} className={`explanation-card-component__decoration-section`}>
                {Component}
            </Col>

            <Col xs={'auto'} className={`explanation-card-component__information-data`}>
                <Row className={`explanation-card-component__information-data__content`}>
                    <CardMainTitleComponent title={cardMainTitle} />
                    {cardDescription &&
                    <CardMainDescriptionComponent>
                        <span>{cardDescription}</span>
                    </CardMainDescriptionComponent>
                    }
                </Row>
            </Col>

        </CardComponent>
    );

};


export default ExplanationCardComponent;
